/* eslint-disable */

import { useEffect, useState } from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';

import { Typography, useTheme } from '@mui/material';

import api from '../../services/api';
import { toast } from 'react-toastify';
import { getStyled } from './styles';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
);

export const ChartsDate = ({ dateFrom, dateTo, finalizadas, canceladas }) => {
  const theme = useTheme();
  const classes = getStyled(theme);

  const [ticketsData, setTicketsData] = useState({ data: [], count: 0 });
  const [totalAtendimentos, setTotalAtendimentos] = useState(0);
  const [gradients, setGradients] = useState([]);

  useEffect(() => {
    handleGetTicketsInformation();
  }, [dateFrom, dateTo, finalizadas, canceladas]);

  useEffect(() => {
    if (!ticketsData?.length) return;

    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    const chartGradients = [];

    ticketsData.forEach(() => {
      const gradient = ctx.createLinearGradient(0, 0, 0, 300);
      gradient.addColorStop(
        1,
        theme.palette.mode === 'light' ? theme.palette.primary.main : '#1D9FF0',
      );
      gradient.addColorStop(
        0,
        theme.palette.mode === 'light' ? theme.palette.primary.dark : '#1471AA',
      );

      chartGradients.push(gradient);
    });

    setGradients(chartGradients);
  }, []);

  const parseDate = (dateStr) => {
    if (!dateStr) return Infinity;
    const [day, month, year] = dateStr.split('/');
    return new Date(`${year}-${month}-${day}`).getTime();
  };

  const dataCharts = {
    labels:
      ticketsData &&
      ticketsData?.length > 0 &&
      [...ticketsData]
        .sort((a, b) =>
          dateFrom === dateTo
            ? (a.horario ?? Infinity) - (b.horario ?? Infinity)
            : parseDate(a.data) - parseDate(b.data),
        )
        .map((item) =>
          item.hasOwnProperty('horario')
            ? `${item.horario}:00 às ${item.horario}:59`
            : item.data,
        ),
    datasets: [
      {
        data:
          ticketsData?.length > 0 &&
          ticketsData?.map((item, index) => {
            return item.quantidade;
          }),
        backgroundColor: gradients,
      },
    ],
  };

  const handleGetTicketsInformation = async () => {
    try {
      const { data } = await api.get(
        `/dashboard/ticketsDay?initialDate=${dateFrom}&finalDate=${dateTo}`,
      );

      const response = data.data
        .map((item) => {
          let quantidade;
          if (finalizadas && !canceladas) quantidade = Number(item.finalizadas);
          if (!finalizadas && canceladas) quantidade = Number(item.canceladas);
          if (finalizadas && canceladas)
            quantidade = Number(item.canceladas) + Number(item.finalizadas);

          if (quantidade > 0) return { ...item, quantidade: quantidade };
          return null;
        })
        .filter((item) => item !== null);

      const list = response.sort((a, b) => {
        const quantidadeA = Number(a.quantidade);
        const quantidadeB = Number(b.quantidade);
        return quantidadeB - quantidadeA;
      });

      let total = 0;

      if (list.length > 1) {
        total = list.reduce((acc, item) => acc + Number(item.quantidade), 0);
      }

      setTotalAtendimentos(total);

      setTicketsData(list);
    } catch (error) {
      toastError('Erro ao buscar informações dos tickets');
    }
  };

  return (
    <>
      <Typography
        component='h2'
        variant='h6'
        sx={{
          color:
            theme.palette.mode === 'dark' ? '#FFF' : theme.palette.primary.main,
        }}
        gutterBottom
      >
        Total de Atendimentos por Data{' '}
        {totalAtendimentos > 0 ? `(${totalAtendimentos})` : ''}
      </Typography>

      <Bar
        options={classes.chartsDateOptions}
        data={dataCharts}
        sx={{ maxWidth: '100%', maxHeight: '280px' }}
      />
    </>
  );
};
